import { Alert, AlertProps, Collapse, CollapseProps, Grid } from "@mui/material";
import { GridProps } from "@mui/system";
import React, { PropsWithChildren } from "react";

interface AlertGridItemProps extends AlertProps, Pick<CollapseProps, "in"> {
  /** The props which should be passed to the Grid wrapper element. */
  gridItemProps?: GridProps;
  /** Grid spacing to apply when shown. */
  spacing?: number;
}

/** Convenience component for rendering a grid item containing a collapsible alert with no footprint when closed. */
const AlertGridItem: React.FC<PropsWithChildren<AlertGridItemProps>> = ({
  in: collapseIn = true,
  gridItemProps,
  spacing,
  children,
  ...rest
}) => {
  return (
    <Grid item {...gridItemProps} sx={{ pt: "0px !important" }}>
      <Collapse in={collapseIn}>
        <Alert {...rest} sx={{ mt: spacing }}>
          {children}
        </Alert>
      </Collapse>
    </Grid>
  );
};

export default AlertGridItem;
